import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { DirectMessageLoginId } from './directMessagesLoginId.action';


const defaultState = {
  mailId: null
}

@State<any>({
  name: 'DirectMessageLoginId',
  defaults: defaultState
})
@Injectable()

export class DirectMessageLoginIdState {

  mailId: number

  @Action(DirectMessageLoginId)
  ErDashBoardData({ getState, patchState }: StateContext<any>, { payload }: any) {


    const state = getState();

    patchState({
      mailId: payload.mailId
    });


  }

}
